import { render, staticRenderFns } from "./VehicleScheduleViewDrawer.vue?vue&type=template&id=4445b3b4&scoped=true"
import script from "./VehicleScheduleViewDrawer.vue?vue&type=script&lang=js"
export * from "./VehicleScheduleViewDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4445b3b4",
  null
  
)

export default component.exports